import classNames from 'classnames';
import { MenuAction, MenuCustomAction, User, UserAccount } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { UserAccountInfo, UserAccountsInfo } from '../../typings/common';
import { Skeleton } from '../Skeleton/Skeleton';

import './HeaderUserInfo.css';

export interface HeaderUserInfoProps {
    cls?: string;
    userAccountsInfo?: UserAccountsInfo;
    yu?: string;
    isAgency?: boolean;
    role?: string;
    isProduction?: boolean;
    passportUrl: string;
    actionsMenu: (MenuAction | MenuCustomAction)[];
    additionalUserInfo: string;
}

const BLOCK = 'header-user-info';

export class HeaderUserInfo extends React.PureComponent<HeaderUserInfoProps> {
    render() {
        const { cls, yu, role, passportUrl, actionsMenu, userAccountsInfo } = this.props;

        if (userAccountsInfo === undefined) {
            return (
                <div className={Bem.cls(BLOCK, 'user-info-skeleton')}>
                    <Skeleton isAnimating={true} height={42} />
                </div>
            );
        }

        const { current } = userAccountsInfo;

        if (!current) {
            return <User cls={classNames(Bem.cls(BLOCK), cls)} pic={true} yu={yu} menuMaxHeight={0} />;
        }

        return (
            <div className={Bem.cls(BLOCK, 'container')}>
                <User
                    cls={classNames(Bem.cls(BLOCK, 'user'), cls)}
                    uid={current.uid}
                    pic={true}
                    avatarId={current.displayName.avatar}
                    // Редирект на главную
                    retpath={`https://${document.location.host}`}
                    name={current.displayName.name}
                    yu={yu}
                    passportHost={passportUrl}
                    actionsMenu={actionsMenu}
                    menuMaxHeight={600}
                >
                    {this.getAccounts()}
                </User>
                <div className={Bem.cls(BLOCK, 'extra')}>
                    <div className={Bem.cls(BLOCK, 'role')}>{role}</div>
                    {this.getUserAdditionalUserInfo()}
                </div>
            </div>
        );
    }

    private getAccounts = () => {
        const { userAccountsInfo } = this.props;

        if (!userAccountsInfo || !userAccountsInfo.data || !userAccountsInfo.current) {
            return null;
        }

        const { current, data } = userAccountsInfo;

        return data
            .filter((account: UserAccountInfo) => account.uid !== current.uid)
            .map((account: UserAccountInfo, key: number) => {
                return (
                    <UserAccount
                        uid={account.uid}
                        key={key}
                        pic={true}
                        avatarId={account.displayName.avatar}
                        name={account.displayName.name}
                    />
                );
            });
    };

    private getUserAdditionalUserInfo = () => {
        const { additionalUserInfo } = this.props;

        if (!additionalUserInfo) {
            return null;
        }

        return <div className={Bem.cls(BLOCK, 'additional-user-info')}>{additionalUserInfo}</div>;
    };
}
